import { render, staticRenderFns } from "./HotelSelection.vue?vue&type=template&id=0cf67a27&"
import script from "./HotelSelection.vue?vue&type=script&lang=js&"
export * from "./HotelSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports